import { MEMBER_EXPORTS_LOCKED, MEMBER_EXPORT_BYPASS_ROLES } from '../constants/dataUsePolicy';
import { useUserRole } from '../contexts/UserRoleContext';

/**
 * Conference-safe export lock for public users. Local government admins and super admins
 * retain CSV/PNG exports, customizable data tables, and the header Download Data modal.
 *
 * REACT_APP_CP_WP006_UNLOCK_EXPORTS=true is a validation-only build flag for CP-WP-006
 * download parity capture; it is not enabled in normal deployment builds.
 */
export function useMemberExportsLocked(): boolean {
  if (process.env.REACT_APP_CP_WP006_UNLOCK_EXPORTS === 'true') return false;
  const { hasAnyRole } = useUserRole();
  if (!MEMBER_EXPORTS_LOCKED) return false;
  if (hasAnyRole([...MEMBER_EXPORT_BYPASS_ROLES])) return false;
  return true;
}
